@if (navigating()) {
  <div class="global-loading-overlay">
    <app-dot-loader />
  </div>
}
<router-outlet />